import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { saveDontShowReIntegrationError, saveDontShowReIntegrationSuccess } from './actions'
import { DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC } from './constants'

const saveDontShowReIntegrationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC.INITIATE),
    mergeMap(() =>
      api.accounts.dontShowReIntegration(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map(() => saveDontShowReIntegrationSuccess()),
        catchError((error) => of(epicsErrorHandler(saveDontShowReIntegrationError, error)))
      )
    )
  )

export default combineEpicsIsolated(saveDontShowReIntegrationEpic)
